module.exports = __webpack_public_path__ + "img/goods-detail-share-icon.649a35df.png";